// Limits collisions with poor actors.
const mediaLibraryPrefix = "media-library-"

export const newMediaLibraryFeaturesBannerClosed = `${mediaLibraryPrefix}newMediaLibraryFeaturesBannerClosed`
